import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import AuthService from '../services/AuthService';
import toast from 'react-hot-toast';

const StudentBlockedRoute = ({ children }) => {
  const { state, actions } = useUser();
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [isStudent, setIsStudent] = useState(false);

  useEffect(() => {
    const checkStudentStatus = async () => {
      // First check if leagueId is in state
      if (state.user?.leagueId) {
        setIsStudent(true);
        setChecking(false);
        toast.error('Student accounts do not have access to this page');
        return;
      }

      // If leagueId is not in state, verify with backend to ensure we have latest data
      // This handles cases where localStorage might have stale data
      if (state.user?.id) {
        try {
          const response = await AuthService.validateToken();
          if (response.valid && response.user) {
            // Update user context with latest data including leagueId
            actions.setUser({
              ...response.user,
              leagueId: response.user.leagueId || null
            });

            // Check if user is a student
            if (response.user.leagueId) {
              setIsStudent(true);
              toast.error('Student accounts do not have access to this page');
            } else {
              setIsStudent(false);
            }
          }
        } catch (error) {
          // If verification fails, check current state
          if (state.user?.leagueId) {
            setIsStudent(true);
            toast.error('Student accounts do not have access to this page');
          } else {
            setIsStudent(false);
          }
        }
      } else {
        setIsStudent(false);
      }
      setChecking(false);
    };

    checkStudentStatus();
  }, [state.user, actions]);

  if (checking) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Block student accounts from accessing this route
  if (isStudent || state.user?.leagueId) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default StudentBlockedRoute;
